module.exports = __webpack_public_path__ + "img/spin-wheel.9f6bd42b.gif";